"use client";

import { useEffect, useRef } from "react";

// Progressive-enhancement reveal: content is visible by default (SEO-safe),
// the "pre" class is only added client-side just before observing.
export default function Reveal({ children, className = "", as: Tag = "div" }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            el.classList.remove("pre");
            io.disconnect();
          }
        });
      },
      { threshold: 0.12 }
    );
    const rect = el.getBoundingClientRect();
    if (rect.top > window.innerHeight * 0.85) {
      el.classList.add("pre");
      io.observe(el);
    }
    return () => io.disconnect();
  }, []);

  return (
    <Tag ref={ref} className={`reveal ${className}`}>
      {children}
    </Tag>
  );
}
